import { useMemo, type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';
import { Text } from 'react-native-paper';

import { LocalizationNameSpace } from '@/localization/types/localizationTypes';
import { useAppTheme } from '@/styles/hooks/useAppTheme';
import type { AppTheme } from '@/styles/theme';
import { dayjs } from '@/time';

const makeStyles = (theme: AppTheme) =>
  StyleSheet.create({
    text: {
      textAlign: 'center',
      color: theme.colors.outline,
      marginHorizontal: 16,
      marginVertical: 8
    }
  });

type Props = { time: number };

export const DaySeparator: FC<Props> = ({ time }) => {
  const theme = useAppTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);
  const { t } = useTranslation(LocalizationNameSpace.CHATS, {
    keyPrefix: 'components.daySeparator'
  });

  const text = useMemo((): string => {
    const timeDate = dayjs(time).startOf('day');
    const currentDate = dayjs().startOf('day');
    const daysInPast = currentDate.diff(timeDate, 'days');
    if (daysInPast === 0) {
      return t('today');
    } else if (daysInPast === 1) {
      return t('yesterday');
    } else if (daysInPast > 1 && daysInPast < 7) {
      return timeDate.format('dddd');
    } else {
      return timeDate.format('dd. D. MMMM');
    }
  }, [t, time]);

  return (
    <Text variant="bodyMedium" style={styles.text}>
      {text}
    </Text>
  );
};
